import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import _ from 'lodash';
import React, { Component } from 'react';
import AccessibilityInfo from "react-native-web/dist/exports/AccessibilityInfo";
import PanResponder from "react-native-web/dist/exports/PanResponder";
import Animated from "react-native-web/dist/exports/Animated";
import View from "react-native-web/dist/exports/View";
import Text from "react-native-web/dist/exports/Text";
import Image from "react-native-web/dist/exports/Image";
import PropTypes from 'prop-types';
import XDate from 'xdate';
import { CALENDAR_KNOB } from "../testIDs";
import dateutils from "../dateutils";
import { parseDate } from "../interface";
import styleConstructor from "./style";
import CalendarList from "../calendar-list";
import Calendar from "../calendar";
import asCalendarConsumer from "./asCalendarConsumer";
import WeekCalendar from "./weekCalendar";
import Week from "./week";
import { jsx as ___EmotionJSX } from "@emotion/core";

var commons = require("./commons");

var UPDATE_SOURCES = commons.UPDATE_SOURCES;
var POSITIONS = {
  CLOSED: 'closed',
  OPEN: 'open'
};
var SPEED = 20;
var BOUNCINESS = 6;
var CLOSED_HEIGHT = 120;
var WEEK_HEIGHT = 46;
var KNOB_CONTAINER_HEIGHT = 20;
var HEADER_HEIGHT = 68;
var DAY_NAMES_PADDING = 24;

var ExpandableCalendar = function (_Component) {
  _inherits(ExpandableCalendar, _Component);

  var _super = _createSuper(ExpandableCalendar);

  function ExpandableCalendar(props) {
    var _this;

    _classCallCheck(this, ExpandableCalendar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleMoveShouldSetPanResponder", function (e, gestureState) {
      if (_this.props.disablePan) {
        return false;
      }

      if (!_this.props.horizontal && _this.state.position === POSITIONS.OPEN) {
        return false;
      }

      if (_this.state.position === POSITIONS.CLOSED && gestureState.dy < 0) {
        return false;
      }

      return gestureState.dy > 5 || gestureState.dy < -5;
    });

    _defineProperty(_assertThisInitialized(_this), "handlePanResponderGrant", function () {});

    _defineProperty(_assertThisInitialized(_this), "handlePanResponderMove", function (e, gestureState) {
      _this._wrapperStyles.style.height = Math.max(_this.closedHeight, _this._height + gestureState.dy);

      if (!_this.props.horizontal) {
        _this._headerStyles.style.top = Math.min(Math.max(-gestureState.dy, -HEADER_HEIGHT), 0);
      } else {
        if (_this.state.position === POSITIONS.CLOSED) {
          _this._weekCalendarStyles.style.opacity = Math.min(1, Math.max(1 - gestureState.dy / 100, 0));
        }
      }

      _this.updateNativeStyles();
    });

    _defineProperty(_assertThisInitialized(_this), "handlePanResponderEnd", function () {
      _this._height = _this._wrapperStyles.style.height;

      _this.bounceToPosition();
    });

    _defineProperty(_assertThisInitialized(_this), "onAnimatedFinished", function (_ref) {
      var finished = _ref.finished;

      if (finished) {}
    });

    _defineProperty(_assertThisInitialized(_this), "onPressArrowLeft", function () {
      _this.scrollPage(false);
    });

    _defineProperty(_assertThisInitialized(_this), "onPressArrowRight", function () {
      _this.scrollPage(true);
    });

    _defineProperty(_assertThisInitialized(_this), "onDayPress", function (value) {
      _.invoke(_this.props.context, 'setDate', value.dateString, UPDATE_SOURCES.DAY_PRESS);

      setTimeout(function () {
        if (_this.state.position === POSITIONS.OPEN) {
          _this.bounceToPosition(_this.closedHeight);
        }
      }, 0);
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibleMonthsChange", function (value) {
      if (_this.visibleMonth !== _.first(value).month) {
        _this.visibleMonth = _.first(value).month;
        var _this$props$context = _this.props.context,
            date = _this$props$context.date,
            updateSource = _this$props$context.updateSource;

        if (_this.visibleMonth !== _this.getMonth(date) && updateSource !== UPDATE_SOURCES.DAY_PRESS) {
          var next = _this.isLaterDate(_.first(value), date);

          _this.scrollPage(next);
        }

        setTimeout(function () {
          var numberOfWeeks = _this.getNumberOfWeeksInMonth(parseDate(_this.props.context.date));

          if (numberOfWeeks !== _this.numberOfWeeks) {
            _this.numberOfWeeks = numberOfWeeks;
            _this.openHeight = _this.getOpenHeight();

            if (_this.state.position === POSITIONS.OPEN) {
              _this.bounceToPosition(_this.openHeight);
            }
          }
        }, 0);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderArrow", function (direction) {
      if (_.isFunction(_this.props.renderArrow)) {
        return _this.props.renderArrow(direction);
      }

      return ___EmotionJSX(Image, {
        source: direction === 'right' ? _this.props.rightArrowImageSource : _this.props.leftArrowImageSource,
        style: _this.style.arrowImage
      });
    });

    _this.style = styleConstructor(props.theme);
    _this.closedHeight = CLOSED_HEIGHT + (props.hideKnob ? 0 : KNOB_CONTAINER_HEIGHT);
    _this.numberOfWeeks = _this.getNumberOfWeeksInMonth(XDate(_this.props.context.date));
    _this.openHeight = _this.getOpenHeight();
    var startHeight = props.initialPosition === POSITIONS.CLOSED ? _this.closedHeight : _this.openHeight;
    _this._height = startHeight;
    _this._wrapperStyles = {
      style: {
        height: startHeight
      }
    };
    _this._headerStyles = {
      style: {
        top: props.initialPosition === POSITIONS.CLOSED ? 0 : -HEADER_HEIGHT
      }
    };
    _this._weekCalendarStyles = {
      style: {}
    };
    _this.wrapper = undefined;
    _this.calendar = undefined;
    _this.visibleMonth = _this.getMonth(_this.props.context.date);
    _this.initialDate = props.context.date;
    _this.headerStyleOverride = {
      'stylesheet.calendar.header': {
        week: {
          marginTop: 7,
          marginBottom: -4,
          flexDirection: 'row',
          justifyContent: 'space-around'
        }
      }
    };
    _this.state = {
      deltaY: new Animated.Value(startHeight),
      headerDeltaY: new Animated.Value(props.initialPosition === POSITIONS.CLOSED ? 0 : -HEADER_HEIGHT),
      position: props.initialPosition,
      screenReaderEnabled: false
    };
    _this.panResponder = PanResponder.create({
      onMoveShouldSetPanResponder: _this.handleMoveShouldSetPanResponder,
      onPanResponderGrant: _this.handlePanResponderGrant,
      onPanResponderMove: _this.handlePanResponderMove,
      onPanResponderRelease: _this.handlePanResponderEnd,
      onPanResponderTerminate: _this.handlePanResponderEnd
    });
    return _this;
  }

  _createClass(ExpandableCalendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      AccessibilityInfo.isScreenReaderEnabled().then(function (screenReaderEnabled) {
        _this2.setState({
          screenReaderEnabled: screenReaderEnabled
        });
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var date = this.props.context.date;

      if (date !== prevProps.context.date) {
        this.scrollToDate(date);
      }
    }
  }, {
    key: "updateNativeStyles",
    value: function updateNativeStyles() {
      this.wrapper && this.wrapper.setNativeProps(this._wrapperStyles);

      if (!this.props.horizontal) {
        this.header && this.header.setNativeProps(this._headerStyles);
      } else {
        this.weekCalendar && this.weekCalendar.setNativeProps(this._weekCalendarStyles);
      }
    }
  }, {
    key: "scrollToDate",
    value: function scrollToDate(date) {
      if (this.calendar) {
        if (!this.props.horizontal) {
          this.calendar.scrollToDay(XDate(date), 0, true);
        } else if (this.getMonth(date) !== this.visibleMonth) {
          this.calendar.scrollToMonth(XDate(date));
        }
      }
    }
  }, {
    key: "scrollPage",
    value: function scrollPage(next) {
      if (this.props.horizontal) {
        var d = parseDate(this.props.context.date);

        if (this.state.position === POSITIONS.OPEN) {
          d.setDate(1);
          d.addMonths(next ? 1 : -1);
        } else {
          var firstDay = this.props.firstDay;
          var dayOfTheWeek = d.getDay();

          if (dayOfTheWeek < firstDay && firstDay > 0) {
            dayOfTheWeek = 7 + dayOfTheWeek;
          }

          var firstDayOfWeek = (next ? 7 : -7) - dayOfTheWeek + firstDay;
          d.addDays(firstDayOfWeek);
        }

        _.invoke(this.props.context, 'setDate', this.getDateString(d), UPDATE_SOURCES.PAGE_SCROLL);
      }
    }
  }, {
    key: "getOpenHeight",
    value: function getOpenHeight() {
      if (!this.props.horizontal) {
        return Math.max(commons.screenHeight, commons.screenWidth);
      }

      return CLOSED_HEIGHT + WEEK_HEIGHT * (this.numberOfWeeks - 1) + (this.props.hideKnob ? 12 : KNOB_CONTAINER_HEIGHT);
    }
  }, {
    key: "getDateString",
    value: function getDateString(date) {
      return date.toString('yyyy-MM-dd');
    }
  }, {
    key: "getYear",
    value: function getYear(date) {
      var d = XDate(date);
      return d.getFullYear();
    }
  }, {
    key: "getMonth",
    value: function getMonth(date) {
      var d = XDate(date);
      return d.getMonth() + 1;
    }
  }, {
    key: "getNumberOfWeeksInMonth",
    value: function getNumberOfWeeksInMonth(month) {
      var days = dateutils.page(month, this.props.firstDay);
      return days.length / 7;
    }
  }, {
    key: "getMarkedDates",
    value: function getMarkedDates() {
      var _this$props = this.props,
          context = _this$props.context,
          markedDates = _this$props.markedDates;

      if (markedDates) {
        var marked = _.cloneDeep(markedDates);

        if (marked[context.date]) {
          marked[context.date].selected = true;
        } else {
          marked[context.date] = {
            selected: true
          };
        }

        return marked;
      }

      return _defineProperty({}, context.date, {
        selected: true
      });
    }
  }, {
    key: "shouldHideArrows",
    value: function shouldHideArrows() {
      if (!this.props.horizontal) {
        return true;
      }

      return this.props.hideArrows || false;
    }
  }, {
    key: "isLaterDate",
    value: function isLaterDate(date1, date2) {
      if (date1.year > this.getYear(date2)) {
        return true;
      }

      if (date1.year === this.getYear(date2)) {
        if (date1.month > this.getMonth(date2)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "bounceToPosition",
    value: function bounceToPosition(toValue) {
      if (!this.props.disablePan) {
        var deltaY = this.state.deltaY;
        var threshold = this.openHeight / 1.75;
        var isOpen = this._height >= threshold;
        var newValue = isOpen ? this.openHeight : this.closedHeight;
        deltaY.setValue(this._height);
        this._height = toValue || newValue;
        isOpen = this._height >= threshold;
        Animated.spring(deltaY, {
          toValue: this._height,
          speed: SPEED,
          bounciness: BOUNCINESS,
          useNativeDriver: false
        }).start(this.onAnimatedFinished);
        this.setPosition();
        this.closeHeader(isOpen);
        this.resetWeekCalendarOpacity(isOpen);
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      var isClosed = this._height === this.closedHeight;
      this.setState({
        position: isClosed ? POSITIONS.CLOSED : POSITIONS.OPEN
      });
    }
  }, {
    key: "resetWeekCalendarOpacity",
    value: function resetWeekCalendarOpacity(isOpen) {
      this._weekCalendarStyles.style.opacity = isOpen ? 0 : 1;
      this.updateNativeStyles();
    }
  }, {
    key: "closeHeader",
    value: function closeHeader(isOpen) {
      var headerDeltaY = this.state.headerDeltaY;
      headerDeltaY.setValue(this._headerStyles.style.top);

      if (!this.props.horizontal && !isOpen) {
        Animated.spring(headerDeltaY, {
          toValue: 0,
          speed: SPEED / 10,
          bounciness: 1,
          useNativeDriver: false
        }).start();
      }
    }
  }, {
    key: "renderWeekDaysNames",
    value: function renderWeekDaysNames() {
      var _this3 = this;

      var weekDaysNames = dateutils.weekDayNames(this.props.firstDay);
      return ___EmotionJSX(View, {
        style: [this.style.weekDayNames, {
          paddingLeft: _.get(this.props, 'calendarStyle.paddingLeft') + 6 || DAY_NAMES_PADDING,
          paddingRight: _.get(this.props, 'calendarStyle.paddingRight') + 6 || DAY_NAMES_PADDING
        }]
      }, weekDaysNames.map(function (day, index) {
        return ___EmotionJSX(Text, {
          allowFontScaling: false,
          key: day + index,
          style: _this3.style.weekday,
          numberOfLines: 1
        }, day);
      }));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this4 = this;

      var monthYear = XDate(this.props.context.date).toString('MMMM yyyy');
      return ___EmotionJSX(Animated.View, {
        ref: function ref(e) {
          return _this4.header = e;
        },
        style: [this.style.header, {
          height: HEADER_HEIGHT,
          top: this.state.headerDeltaY
        }],
        pointerEvents: 'none'
      }, ___EmotionJSX(Text, {
        allowFontScaling: false,
        style: this.style.headerTitle
      }, monthYear), this.renderWeekDaysNames());
    }
  }, {
    key: "renderWeekCalendar",
    value: function renderWeekCalendar() {
      var _this5 = this;

      var position = this.state.position;
      var disableWeekScroll = this.props.disableWeekScroll;
      var WeekComponent = disableWeekScroll ? Week : WeekCalendar;
      return ___EmotionJSX(Animated.View, {
        ref: function ref(e) {
          return _this5.weekCalendar = e;
        },
        style: {
          position: 'absolute',
          left: 0,
          right: 0,
          top: HEADER_HEIGHT + (commons.isAndroid ? 8 : 4),
          opacity: position === POSITIONS.OPEN ? 0 : 1
        },
        pointerEvents: position === POSITIONS.CLOSED ? 'auto' : 'none'
      }, ___EmotionJSX(WeekComponent, _extends({}, this.props, {
        current: this.props.context.date,
        onDayPress: this.onDayPress,
        markedDates: this.getMarkedDates(),
        style: this.props.calendarStyle,
        allowShadow: false,
        hideDayNames: true,
        accessibilityElementsHidden: true,
        importantForAccessibility: 'no-hide-descendants'
      })));
    }
  }, {
    key: "renderKnob",
    value: function renderKnob() {
      return ___EmotionJSX(View, {
        style: this.style.knobContainer,
        pointerEvents: 'none'
      }, ___EmotionJSX(View, {
        style: this.style.knob,
        testID: CALENDAR_KNOB
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      var _this$props2 = this.props,
          style = _this$props2.style,
          hideKnob = _this$props2.hideKnob,
          horizontal = _this$props2.horizontal,
          allowShadow = _this$props2.allowShadow,
          theme = _this$props2.theme,
          others = _objectWithoutProperties(_this$props2, ["style", "hideKnob", "horizontal", "allowShadow", "theme"]);

      var _this$state = this.state,
          deltaY = _this$state.deltaY,
          position = _this$state.position,
          screenReaderEnabled = _this$state.screenReaderEnabled;
      var isOpen = position === POSITIONS.OPEN;

      var themeObject = _extends(this.headerStyleOverride, theme);

      return ___EmotionJSX(View, {
        testID: this.props.testID,
        style: [allowShadow && this.style.containerShadow, style]
      }, screenReaderEnabled ? ___EmotionJSX(Calendar, _extends({
        testID: "calendar"
      }, others, {
        theme: themeObject,
        onDayPress: this.onDayPress,
        markedDates: this.getMarkedDates(),
        hideExtraDays: true,
        renderArrow: this.renderArrow
      })) : ___EmotionJSX(Animated.View, _extends({
        ref: function ref(e) {
          _this6.wrapper = e;
        },
        style: {
          height: deltaY
        }
      }, this.panResponder.panHandlers), ___EmotionJSX(CalendarList, _extends({
        testID: "calendar",
        horizontal: horizontal
      }, others, {
        theme: themeObject,
        ref: function ref(r) {
          return _this6.calendar = r;
        },
        current: this.initialDate,
        onDayPress: this.onDayPress,
        onVisibleMonthsChange: this.onVisibleMonthsChange,
        pagingEnabled: true,
        scrollEnabled: isOpen,
        markedDates: this.getMarkedDates(),
        hideArrows: this.shouldHideArrows(),
        onPressArrowLeft: this.onPressArrowLeft,
        onPressArrowRight: this.onPressArrowRight,
        hideExtraDays: !horizontal,
        renderArrow: this.renderArrow,
        staticHeader: true
      })), horizontal && this.renderWeekCalendar(), !hideKnob && this.renderKnob(), !horizontal && this.renderHeader()));
    }
  }]);

  return ExpandableCalendar;
}(Component);

_defineProperty(ExpandableCalendar, "displayName", 'ExpandableCalendar');

_defineProperty(ExpandableCalendar, "propTypes", _objectSpread({}, CalendarList.propTypes, {
  initialPosition: PropTypes.oneOf(_.values(POSITIONS)),
  disablePan: PropTypes.bool,
  hideKnob: PropTypes.bool,
  leftArrowImageSource: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.func]),
  rightArrowImageSource: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.func]),
  allowShadow: PropTypes.bool,
  disableWeekScroll: PropTypes.bool
}));

_defineProperty(ExpandableCalendar, "defaultProps", {
  horizontal: true,
  initialPosition: POSITIONS.CLOSED,
  firstDay: 0,
  leftArrowImageSource: require("../calendar/img/previous.png"),
  rightArrowImageSource: require("../calendar/img/next.png"),
  allowShadow: true
});

_defineProperty(ExpandableCalendar, "positions", POSITIONS);

var __DOCZ_DUMMY_EXPORT_DEFAULT = asCalendarConsumer(ExpandableCalendar);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/index.js"
    }
  });
}